import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import colors, {
  StyledForm,
  Success,
  Cancel,
} from "../../components/300/UiComponent";
import {
  Formik,
  useFormik,
  Form,
  Field,
  FieldArray,
  ErrorMessage,
} from "formik";
import { css } from "@emotion/react";
import * as yup from "yup";
import ImportStaff from "../300/course/ImportModal";
import CircularProgress from "@mui/material/CircularProgress";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
//context provider
import OfficeContext from "../../context/OfficeContext";

import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  Grid,
  Autocomplete,
} from "@mui/material";
import { FormatLineSpacing } from "@mui/icons-material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/300/styles";
import PositionContext from "../../context/PositionContext";
import { AddPos, RegisterPosition } from "./RegisterOffice";
// Here the drop down menu

const officeValidationSchema = yup.object({
  id: yup.string("Enter Office ID").required("Office ID is required"),
  name: yup.string("Enter Office name").required("Office name is required"),
  type: yup.string("Enter office type ").required("Office type is required"),
  position_id: yup.string("Enter Position").required("Position is required"),
});

function EditOffice() {
  const officeContext = useContext(OfficeContext);
  const positionContext = useContext(PositionContext);
  const location = useLocation();
  const navigate = useNavigate();
  const api = useAxiosPrivate();
  const [open, setOpen] = useState(false);
  const [types, setTypes] = useState([]);

  // for loading
  const [adding, setAdding] = useState(false);
  //for snackbar
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const [modalState, setModalState] = useState({
    open: false,
    overlay: false,
  });

  useEffect(() => {
    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
  }, []);

  useEffect(() => {
    api.get("position/positions").then((res) => {
      //console.log(curriculum.data.curriculums);
      console.log(res);
      positionContext.positionDispatch({
        type: "loadPosition",
        positions: res.data.positions,
      });
    });
  }, [modalState]);

  useEffect(() => {
    let types = officeContext.officeState.map((o) => o.type);
    setTypes(types?.filter((val, index) => types.indexOf(val) == index));

    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
  }, []);

  let office = officeContext.officeState.filter((elem) => {
    return elem.id == location.state.id;
  })[0];
  let officePositions = officeContext.officeState.map((office) => {
    return office.position_id;
  });

  //const formik = useFormik({
  //  initialValues: {
  //    id: office.id,
  //    name: office.name,
  //    type: office.type,
  //    position_id: office.position_id,
  //  },
  //  validationSchema: validationSchema,
  //  onSubmit: (values) => {
  //    let newValues = { ...values, oldID: location.state.id };
  //    alert(JSON.stringify(newValues, null, 2));

  //    api
  //      .patch("office/updateOffice", newValues)
  //      .then((res) => {
  //        setAdding(false);
  //        navigate("../", {
  //          state: {
  //            message: { message: "Updated Successfully", type: "success" },
  //            open: true,
  //          },
  //        });
  //      })
  //      .catch((err) => {
  //        console.log(err);
  //        setAdding(false);
  //        setSnackBarOpen(true);
  //        setMessage({ message: err.response.data.message, type: "error" });
  //      });
  //  },
  //});

  return (
    <>
      <Formik
        initialValues={{
          id: office.id,
          name: office.name,
          type: office.type,
          position_id: office.position_id,
        }}
        validationSchema={officeValidationSchema}
        onSubmit={(values) => {
          let newValues = { ...values, oldID: location.state.id };
          alert(JSON.stringify(newValues, null, 2));

          api
            .patch("office/updateOffice", newValues)
            .then((res) => {
              setAdding(false);
              navigate("../", {
                state: {
                  message: { message: "Updated Successfully", type: "success" },
                  open: true,
                },
              });
            })
            .catch((err) => {
              console.log(err);
              setAdding(false);
              setSnackBarOpen(true);
              setMessage({ message: err.response.data.message, type: "error" });
            });
        }}
      >
        {({
          handleChange,
          values,
          setFieldValue,
          errors,
          touched,
          handleSubmit,
        }) => (
          <Form
            onSubmit={handleSubmit}
            style={{
              //border: "1px solid black",
              width: "100%",
              padding: "40px 25px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "30px",
              backgroundColor: "white",
              borderRadius: "8px",
              h3: {
                padding: "0px 10px 30px 0px",
                color: `${colors.primary400}`,
                fontSize: "20px",
                fontWeight: 500,
                flexBasis: "100%",
                borderBottom: `0.5px solid ${colors.third100}`,
              },
              row: {
                display: "flex",
                gap: "15px",
              },
              btnGroup: {
                display: "flex",
                gap: "20px",
                paddingTop: "30px",
                width: "100%",
                justifyContent: "flex-end",
              },
            }}
          >
            <Box sx={header}>
              <Typography
                variant="span"
                sx={{
                  fontSize: "1.14rem",
                  fontWeight: "600",
                  lineHeight: "23.2px",
                  color: "primary.main",
                }}
              >
                Edit Office
              </Typography>
            </Box>
            <Grid container spacing={2} sx={{ ...formGroupContainer, gap: 0 }}>
              <Grid
                item
                lg={3}
                md={6}
                sm={12}
                sx={{ ...row, padding: "20px 0px" }}
              >
                <FormControl sx={groupStyled}>
                  <FormLabel sx={labelStyled}>ID</FormLabel>
                  <TextField
                    id="id"
                    name="id"
                    value={values.id}
                    onChange={(e) => {
                      setSnackBarOpen(false);
                      handleChange(e);
                    }}
                    error={errors.id && Boolean(errors.id)}
                    helperText={touched.id && errors.id}
                    fullWidth
                  />
                </FormControl>
              </Grid>
              <Grid
                item
                lg={3}
                md={6}
                sm={12}
                sx={{ ...row, padding: "20px 0px" }}
              >
                <FormControl sx={groupStyled}>
                  <FormLabel sx={labelStyled}>Name</FormLabel>
                  <TextField
                    id="name"
                    name="name"
                    value={values.name}
                    onChange={(e) => {
                      setSnackBarOpen(false);
                      handleChange(e);
                    }}
                    error={errors.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    fullWidth
                  />
                </FormControl>
              </Grid>
              <Grid
                item
                lg={3}
                md={6}
                sm={12}
                sx={{ ...row, padding: "20px 0px" }}
              >
                <FormControl sx={groupStyled}>
                  <FormLabel htmlFor="type" sx={labelStyled}>
                    Type
                  </FormLabel>

                  <Autocomplete
                    id="autostream"
                    //name="city_id"
                    freeSolo
                    options={types}
                    value={values.type}
                    //groupBy={(option) => option.state}
                    //getOptionLabel={(option) => option.name}
                    onChange={(e, newValue) => {
                      console.log(newValue);
                      setFieldValue("type", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        id="type"
                        name="type"
                        {...params}
                        onChange={handleChange}
                        value={values.type}
                        error={errors.type && Boolean(errors.type)}
                        helperText={touched.type && errors.type}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid
                item
                lg={3}
                md={6}
                sm={12}
                sx={{ ...row, padding: "20px 0px" }}
              >
                <FormControl sx={groupStyled}>
                  <FormLabel htmlFor="type" sx={labelStyled}>
                    Position
                  </FormLabel>
                  <TextField
                    id="position_id"
                    name="position_id"
                    onChange={handleChange}
                    error={touched.position_id && Boolean(errors.position_id)}
                    value={values.position_id}
                    helperText={touched.position_id && errors.position_id}
                    select
                  >
                    {positionContext.positionState
                      .filter(
                        (position) =>
                          position.status == 1 &&
                          (values.position_id ||
                            !officePositions.includes(position.id))
                      )
                      .map((option) => (
                        <MenuItem key={option.title} value={option.id}>
                          {option.title}
                        </MenuItem>
                      ))}
                    <MenuItem key="1" value="">
                      <AddPos setModalState={setModalState} />
                    </MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>
            {snackBarOpen && (
              <CustomizedSnackbars
                {...{ setSnackBarOpen, snackBarOpen, message }}
              />
            )}

            <Box
              sx={{
                display: "flex",
                gap: "1.8rem",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <NavLink to={"../"} style={{ textDecoration: "none" }}>
                <Button variant="outlined" color="third">
                  Cancel
                </Button>
              </NavLink>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "secondary.main",
                  "&:hover": {
                    backgroundColor: "secondary.hover",
                  },
                }}
                type="submit"
              >
                Update
              </Button>
            </Box>
            <Dialog open={modalState.open}>
              <RegisterPosition
                {...{
                  setModalState,
                  modalState,
                  setMainMessage: setMessage,
                  setMainSnack: setSnackBarOpen,
                }}
              />
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default EditOffice;
